"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.healthContract = exports.HealthSchema = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@ts-rest/core");
const zod_1 = tslib_1.__importDefault(require("zod"));
const c = (0, core_1.initContract)();
exports.HealthSchema = zod_1.default.object({
    version: zod_1.default.string(),
    gitSha: zod_1.default.string(),
    release: zod_1.default.string(),
    dependencies: zod_1.default.object({
        regionalApiHealthStatus: zod_1.default.number(),
    }),
});
exports.healthContract = c.router({
    getHealth: {
        method: 'GET',
        path: '/health',
        responses: {
            [200]: exports.HealthSchema,
            [500]: exports.HealthSchema,
        },
        summary: 'Perform a health check and return version information',
    },
}, {
    strictStatusCodes: true,
});
